import React from "react";
import FormattedMessage from "@irati/utils/lang";
import { Body } from "@irati/ui/src/Typography";
var TemplateFindOutMore = function () { return (React.createElement(Body, { small: true, color: "white", textAlign: "center" },
    React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.template.findOutMore" }))); };
export default TemplateFindOutMore;
